import { EmbedDataPointContext } from 'client/shared/components/visualization-picker';
import * as React from 'react';
import { ContentUnavailableType } from 'client/shared/components/content-unavailable';
import { VisualizationUnavailable } from 'client/shared/components/visualization-picker/not-found';
import { useQueryInfo } from 'client/shared/containers/query';
import { QueryInfos } from 'client/shared/graphql-queries';
import { PerformanceDataTx } from 'client/shared/graphql-util/transforms';
import _ from 'lodash';
import { extractVariableIdFromConcatenatedVisualizationId } from 'client/shared/helpers';
import { SavedDataPoint } from 'client/shared/components/saved-data-point';

export const EmbedVisualization: React.FC<{
  readonly visualizationId: string;
}> = (props) => {
  const [expandedVisualization, setExpandedVisualization] = React.useState(true);
  const visualizationQuery = useQueryInfo(QueryInfos.adminOpenVisualization, {
    variables: { visualizationId: props.visualizationId },
  });

  if (
    (visualizationQuery.loading && !visualizationQuery.data) ||
    !visualizationQuery.data
  ) {
    return null;
  }

  const visualization =
    visualizationQuery.data.openSavedTrackVariableVisualizationById;
  if (!visualization) {
    return <VisualizationUnavailable type={ContentUnavailableType.NOT_FOUND} />;
  }

  // below assumes that each visualization can only be linked with one plan- may change as strategic plans schema expands
  const plan = visualization.plans.at(0);

  const goalsByVariableId = _.keyBy(plan?.goals ?? [], (goal) => goal.variable.id);

  const transformed = PerformanceDataTx.gqlVisualization_toClient(visualization);
  const variableId = extractVariableIdFromConcatenatedVisualizationId(
    transformed.trackVariables[0].id,
    visualization.id
  );
  const goalForVar = goalsByVariableId[variableId];

  const trackVariable = transformed.trackVariables.at(0);

  if (!trackVariable) {
    return null;
  }

  const handleToggleExpandedVisualization = () =>
    setExpandedVisualization(!expandedVisualization);
  return (
    <div className="pn-embedded-visualization">
      <SavedDataPoint
        embedContext={EmbedDataPointContext.VISUALIZATION}
        expanded={expandedVisualization}
        goal={goalForVar}
        toggleExpanded={handleToggleExpandedVisualization}
        topLevelEmbed
        {...transformed}
        mapData={{
          fipsAreasShapes: transformed.placeShapeByFips,
          mapBoundCoordinates: transformed.mapBoundCoordinates,
        }}
        savedDataPointState={transformed.state}
        trackVariable={trackVariable}
      />
    </div>
  );
};
